/* eslint-disable no-console */
import axios from 'axios';

import {STRATEGY_BASE_URL} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const userGroupTypeJson = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const {setUserGroupTypes, userGroupTypes} = useJSONStore.getState();

  if (userGroupTypes.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${STRATEGY_BASE_URL}/stakeholdergroup?type=External`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setUserGroupTypes(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default userGroupTypeJson;
